import styled from "styled-components";

const Divider = styled.div`
  width: 200px;
  height: 1px;
  background-color: #555;
`;

export default Divider;
